export default __webpack_public_path__ + "static/media/doctor.36c4ee4e.png";